module.exports = __webpack_public_path__ + "static/FrozenVegi-242f4e42ee0d9ef12e1070f5a69457ef.png";